import { render } from "./StatsProgress.vue?vue&type=template&id=a57841c6&scoped=true&lang=pug"
import script from "./StatsProgress.vue?vue&type=script&setup=true&lang=js"
export * from "./StatsProgress.vue?vue&type=script&setup=true&lang=js"

import "./StatsProgress.vue?vue&type=style&index=0&id=a57841c6&lang=sass&scoped=true"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a57841c6"]])

export default __exports__